<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container-fluid search-results" infiniteScroll [infiniteScrollDistance]="1"
         [infiniteScrollThrottle]="100"
         (scrolled)="fn_getStoreList()">

      <h5 class="page-title">
        Store Gallery
      </h5>

      <div class="white-background">
        <form class="example-form pull-right" [formGroup]="searchStoreForm">
          <div class="srch-flt-rt">
            <mat-form-field class="example-full-width">
              <input matInput placeholder="Search Store" formControlName="searchStore"
                     ng-model-options="{debounce: 10000}" (change)="fn_searchStore(searchStoreForm)">
            </mat-form-field>
          </div>
        </form>
        <div class="clearfix"></div>



        <!-- STORE GALLERY -->
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <div class="display-table crt-st-cl">
              <div class="display-cell">
                <div class="crt-store">
                  <div class="store-bx crt-store-bx">
                    <a class="crt-blk-st" (click)="createStore()">
                      <i class="material-icons">add</i>
                      <p>Create Store</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let store of storeList" class="col-md-4 col-sm-6">
            <app-store-list-item-sub-component [store]="store"></app-store-list-item-sub-component>
          </div>

        </div>
        <app-lazy-loader></app-lazy-loader>
      </div>
    </div>

    <br />
    <br />
  </div>
</main>
